export const achievementData = {
    bio : "Putting quantified achievements on a resume is great, but I just don’t work with hard numbers. I have no data to support the quality of my work. If you have lots of relevant experience, the heading statement of your resume will be a summary.",
    achievements : [
        {
            id : 1,
            title : 'Data Structure And Algorithms Python: The Complete Bootcamp',
            details : 'A python course from Udemy',
            date : 'May, 2022',
            field : 'DSA',
            image : 'https://udemy-certificate.s3.amazonaws.com/image/UC-65c0c5ca-811a-4bba-af5b-77b1afd51c9f.jpg'
        },
        // {
        //     id : 2,
        //     title : 'The Ultimate MySQL Bootcamp: Go from SQL Beginner to Expert',
        //     details : 'A MySQL course from Udemy',
        //     date : 'May 25, 2021',
        //     field : 'Database',
        //     image : 'https://udemy-certificate.s3.amazonaws.com/image/UC-91ae3ea2-39ee-4a57-bf23-d397aff0d9a7.jpg?v=1621951317000'
        // },
        // {
        //     id : 3,
        //     title : 'Machine Learning A-Z: Hands-On Python & R in Data Science',
        //     details : 'Data Science Course from Udemy',
        //     date : 'Apr 13, 2021',
        //     field : 'Machine Learning',
        //     image : 'https://udemy-certificate.s3.amazonaws.com/image/UC-d9a7ba99-8635-47e6-96fc-7dd26a3dcbf1.jpg?v=1618297236000'
        // },
        // {
        //     id : 3,
        //     title : 'R Programming A-Z: R For Data Science With Real Exercises!',
        //     details : 'R Programming Language Course from Udemy',
        //     date : 'Feb 28, 2021',
        //     field : 'Data Science',
        //     image : 'https://udemy-certificate.s3.amazonaws.com/image/UC-8f5ff8e8-b6a4-4efd-a3fc-7fb63b29e77f.jpg?v=1614489452000'
        // }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/